var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBannerBg209B7822A63Dca486753(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 192,
    height: 82,
    viewBox: "0 0 192 82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_798",
    "data-name": "Rectangle 798",
    width: 192,
    height: 82,
    transform: "translate(5351 -419)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_42",
    "data-name": "Mask Group 42",
    transform: "translate(-5351 419)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Add_Icon",
    "data-name": "Add Icon",
    transform: "translate(3792 -682)",
    opacity: 0.39
  }, /*#__PURE__*/React.createElement("g", {
    id: "Plus",
    transform: "translate(1684 266.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-2",
    "data-name": "Plus",
    transform: "translate(1684 278.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-2",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-2",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-3",
    "data-name": "Plus",
    transform: "translate(1684 290.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-3",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-3",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-4",
    "data-name": "Plus",
    transform: "translate(1684 302.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-4",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-4",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-5",
    "data-name": "Plus",
    transform: "translate(1684 314.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-5",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-5",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-6",
    "data-name": "Plus",
    transform: "translate(1684 326.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-6",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-6",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-7",
    "data-name": "Plus",
    transform: "translate(1684 338.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-7",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-7",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-8",
    "data-name": "Plus",
    transform: "translate(1684 350.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-8",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-8",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-9",
    "data-name": "Plus",
    transform: "translate(1684 362.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-9",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-9",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-10",
    "data-name": "Plus",
    transform: "translate(1684 374.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-10",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-10",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-11",
    "data-name": "Plus",
    transform: "translate(1684 386.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-11",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-11",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-12",
    "data-name": "Plus",
    transform: "translate(1672 290.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-12",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-12",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-13",
    "data-name": "Plus",
    transform: "translate(1672 302.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-13",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-13",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-14",
    "data-name": "Plus",
    transform: "translate(1672 314.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-14",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-14",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-15",
    "data-name": "Plus",
    transform: "translate(1672 326.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-15",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-15",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-16",
    "data-name": "Plus",
    transform: "translate(1660 290.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-16",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-16",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-17",
    "data-name": "Plus",
    transform: "translate(1660 302.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-17",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-17",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-18",
    "data-name": "Plus",
    transform: "translate(1660 314.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-18",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-18",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-19",
    "data-name": "Plus",
    transform: "translate(1660 326.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-19",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-19",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-20",
    "data-name": "Plus",
    transform: "translate(1660 338.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-20",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-20",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-21",
    "data-name": "Plus",
    transform: "translate(1660 350.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-21",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-21",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-22",
    "data-name": "Plus",
    transform: "translate(1660 362.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-22",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-22",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-23",
    "data-name": "Plus",
    transform: "translate(1660 374.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-23",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-23",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-24",
    "data-name": "Plus",
    transform: "translate(1648 290.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-24",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-24",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-25",
    "data-name": "Plus",
    transform: "translate(1648 302.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-25",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-25",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-26",
    "data-name": "Plus",
    transform: "translate(1648 314.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-26",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-26",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-27",
    "data-name": "Plus",
    transform: "translate(1648 326.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-27",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-27",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-28",
    "data-name": "Plus",
    transform: "translate(1648 338.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-28",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-28",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-29",
    "data-name": "Plus",
    transform: "translate(1648 350.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-29",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-29",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-30",
    "data-name": "Plus",
    transform: "translate(1648 362.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-30",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-30",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-31",
    "data-name": "Plus",
    transform: "translate(1648 374.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-31",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-31",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-32",
    "data-name": "Plus",
    transform: "translate(1600 290.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-32",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-32",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-33",
    "data-name": "Plus",
    transform: "translate(1636 302.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-33",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-33",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-34",
    "data-name": "Plus",
    transform: "translate(1636 314.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-34",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-34",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-35",
    "data-name": "Plus",
    transform: "translate(1636 326.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-35",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-35",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-36",
    "data-name": "Plus",
    transform: "translate(1636 338.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-36",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-36",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-37",
    "data-name": "Plus",
    transform: "translate(1636 350.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-37",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-37",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-38",
    "data-name": "Plus",
    transform: "translate(1636 362.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-38",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-38",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-39",
    "data-name": "Plus",
    transform: "translate(1636 374.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-39",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-39",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-40",
    "data-name": "Plus",
    transform: "translate(1624 302.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-40",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-40",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-41",
    "data-name": "Plus",
    transform: "translate(1624 314.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-41",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-41",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-42",
    "data-name": "Plus",
    transform: "translate(1624 326.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-42",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-42",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-43",
    "data-name": "Plus",
    transform: "translate(1624 338.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-43",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-43",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-44",
    "data-name": "Plus",
    transform: "translate(1624 350.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-44",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-44",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-45",
    "data-name": "Plus",
    transform: "translate(1624 362.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-45",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-45",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-46",
    "data-name": "Plus",
    transform: "translate(1624 374.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-46",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-46",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-47",
    "data-name": "Plus",
    transform: "translate(1612 302.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-47",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-47",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-48",
    "data-name": "Plus",
    transform: "translate(1612 314.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-48",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-48",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-49",
    "data-name": "Plus",
    transform: "translate(1612 326.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-49",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-49",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-50",
    "data-name": "Plus",
    transform: "translate(1612 338.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-50",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-50",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-51",
    "data-name": "Plus",
    transform: "translate(1612 350.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-51",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-51",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-52",
    "data-name": "Plus",
    transform: "translate(1612 362.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-52",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-52",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-53",
    "data-name": "Plus",
    transform: "translate(1612 374.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-53",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-53",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-54",
    "data-name": "Plus",
    transform: "translate(1600 314.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-54",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-54",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-55",
    "data-name": "Plus",
    transform: "translate(1600 326.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-55",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-55",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-56",
    "data-name": "Plus",
    transform: "translate(1600 338.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-56",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-56",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-57",
    "data-name": "Plus",
    transform: "translate(1600 350.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-57",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-57",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-58",
    "data-name": "Plus",
    transform: "translate(1576 314.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-58",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-58",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-59",
    "data-name": "Plus",
    transform: "translate(1576 326.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-59",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-59",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-60",
    "data-name": "Plus",
    transform: "translate(1576 338.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-60",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-60",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-61",
    "data-name": "Plus",
    transform: "translate(1672 350.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-61",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-61",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-62",
    "data-name": "Plus",
    transform: "translate(1672 362.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-62",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-62",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-63",
    "data-name": "Plus",
    transform: "translate(1708 374.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-63",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-63",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-64",
    "data-name": "Plus",
    transform: "translate(1588 326.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-64",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-64",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-65",
    "data-name": "Plus",
    transform: "translate(1588 338.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-65",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-65",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-66",
    "data-name": "Plus",
    transform: "translate(1588 350.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-66",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-66",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-67",
    "data-name": "Plus",
    transform: "translate(1564 314.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-67",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-67",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-68",
    "data-name": "Plus",
    transform: "translate(1564 326.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-68",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-68",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-69",
    "data-name": "Plus",
    transform: "translate(1564 338.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-69",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-69",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-70",
    "data-name": "Plus",
    transform: "translate(1708 266.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-70",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-70",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-71",
    "data-name": "Plus",
    transform: "translate(1708 278.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-71",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-71",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-72",
    "data-name": "Plus",
    transform: "translate(1708 290.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-72",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-72",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-73",
    "data-name": "Plus",
    transform: "translate(1708 302.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-73",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-73",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-74",
    "data-name": "Plus",
    transform: "translate(1708 314.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-74",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-74",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-75",
    "data-name": "Plus",
    transform: "translate(1708 326.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-75",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-75",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-76",
    "data-name": "Plus",
    transform: "translate(1708 338.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-76",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-76",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-77",
    "data-name": "Plus",
    transform: "translate(1708 350.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-77",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-77",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-78",
    "data-name": "Plus",
    transform: "translate(1696 266.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-78",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-78",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-79",
    "data-name": "Plus",
    transform: "translate(1696 278.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-79",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-79",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-80",
    "data-name": "Plus",
    transform: "translate(1696 290.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-80",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-80",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-81",
    "data-name": "Plus",
    transform: "translate(1696 302.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-81",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-81",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-82",
    "data-name": "Plus",
    transform: "translate(1696 314.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-82",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-82",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-83",
    "data-name": "Plus",
    transform: "translate(1696 326.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-83",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-83",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-84",
    "data-name": "Plus",
    transform: "translate(1696 338.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-84",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-84",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-85",
    "data-name": "Plus",
    transform: "translate(1696 350.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-85",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-85",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-86",
    "data-name": "Plus",
    transform: "translate(1696 362.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-86",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-86",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-87",
    "data-name": "Plus",
    transform: "translate(1696 374.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-87",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-87",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-88",
    "data-name": "Plus",
    transform: "translate(1696 386.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-88",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-88",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-89",
    "data-name": "Plus",
    transform: "translate(1720 266.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-89",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-89",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-90",
    "data-name": "Plus",
    transform: "translate(1720 278.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-90",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-90",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-91",
    "data-name": "Plus",
    transform: "translate(1720 290.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-91",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-91",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-92",
    "data-name": "Plus",
    transform: "translate(1720 302.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-92",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-92",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-93",
    "data-name": "Plus",
    transform: "translate(1732 266.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-93",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-93",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-94",
    "data-name": "Plus",
    transform: "translate(1732 278.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-94",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-94",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-95",
    "data-name": "Plus",
    transform: "translate(1732 290.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-95",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-95",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-96",
    "data-name": "Plus",
    transform: "translate(1732 302.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-96",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-96",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-97",
    "data-name": "Plus",
    transform: "translate(1732 314.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-97",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-97",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-98",
    "data-name": "Plus",
    transform: "translate(1732 326.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-98",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-98",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-99",
    "data-name": "Plus",
    transform: "translate(1732 338.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-99",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-99",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-100",
    "data-name": "Plus",
    transform: "translate(1732 350.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-100",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-100",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-101",
    "data-name": "Plus",
    transform: "translate(1732 362.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-101",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-101",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-102",
    "data-name": "Plus",
    transform: "translate(1732 374.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-102",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-102",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-103",
    "data-name": "Plus",
    transform: "translate(1720 326.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-103",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-103",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-104",
    "data-name": "Plus",
    transform: "translate(1720 338.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-104",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-104",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-105",
    "data-name": "Plus",
    transform: "translate(1720 350.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-105",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-105",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-106",
    "data-name": "Plus",
    transform: "translate(1720 362.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-106",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-106",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-107",
    "data-name": "Plus",
    transform: "translate(1720 374.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-107",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-107",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-108",
    "data-name": "Plus",
    transform: "translate(1744 278.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-108",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-108",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-109",
    "data-name": "Plus",
    transform: "translate(1744 290.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-109",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-109",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-110",
    "data-name": "Plus",
    transform: "translate(1744 302.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-110",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-110",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-111",
    "data-name": "Plus",
    transform: "translate(1744 314.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-111",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-111",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-112",
    "data-name": "Plus",
    transform: "translate(1744 326.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-112",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-112",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-113",
    "data-name": "Plus",
    transform: "translate(1744 338.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-113",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-113",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-114",
    "data-name": "Plus",
    transform: "translate(1744 350.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-114",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-114",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-115",
    "data-name": "Plus",
    transform: "translate(1744 362.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-115",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-115",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Plus-116",
    "data-name": "Plus",
    transform: "translate(1744 374.5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_19-116",
    "data-name": "Line 19",
    y2: 5,
    transform: "translate(2.5 0)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_20-116",
    "data-name": "Line 20",
    y2: 5,
    transform: "translate(5 2.5) rotate(90)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerBg209B7822A63Dca486753);
export default __webpack_public_path__ + "static/media/banner-bg.209b7822a63dca486753.6771e5b254f54e6496e0b9f00c025481.svg";
export { ForwardRef as ReactComponent };